export default {
  fr: {
    thanks: 'Merci pour votre message, nous vous répondrons au plus vite.',
    label: {
      name: 'Votre nom (obligatoire)',
      email: 'Votre adresse email (obligatoire)',
      message: 'Votre message (obligatoire)',
    },
    errors: {
      nameEmpty: 'Vous devez indiquer votre nom',
      emailEmpty: 'Vous devez indiquer votre email',
      emailError: 'Votre email comporte une erreur',
      messageEmpty: 'Vous devez indiquer votre message',
    },
    actions: {
      button: 'Envoyer le message',
    },
  },
};
